const recetaHelpers = require('./recetaHelpers');
const pdpHelpers = require('./pdpHelpers');
const SINGLE_EYE_PLAN_VALUE = 'singleEyePlans';

$('#recetaRut').on('keypress', function(event){
  return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode === 107 || event.charCode === 75);
});



$('.subscription-pdp .repite-receta-button, .subscription-pdp #repite-receta-accordion2-header').on('click',function () {
    if ($("input[name='isFlowStoreSubscription']").data('flow-store-subscription')) {
        recetaHelpers.canBeAddedToCart();
    }
});

$("#hackForDisabledSelector").on('click',function(ev){
    pdpHelpers.validateSubscriptionEyeSelection();
    pdpHelpers.validateOnEyeEyeSelection();
});

$(".buscar-receta-button").on('click',function(ev){
    pdpHelpers.validateSubscriptionEyeSelection();
    pdpHelpers.validateOnEyeEyeSelection();
});

$(".step1 input:radio[name='step1']").on('click', function() {
    recetaHelpers.canBeAddedToCart();
    $('.step1dot1').addClass('d-none');
    $("#recetaCompleta").attr("data-receta-completa", "");
    $('#recetaRut').val('');
    $('.resultado-busqueda-receta').hide();
    $(".add-to-cart-ryk").prop("disabled", true);
    recetaHelpers.handleConfigureBtn(true);

    if (this.value === SINGLE_EYE_PLAN_VALUE && this.checked) {
        $('.step1dot1').removeClass('d-none');
    }
});

$('body').on('click', '.tabs-suscripcion', function() {
    $(".upload-your-recipe-title").removeClass("scroll-focused");
    $(".tabs-suscripcion").removeClass("scroll-focused");
});


$(".step1dot1 input:radio[name='step1.1']").on('click', function() {
    $('.step1dot1 .step1-options-error-message').addClass('d-none');
    $('.step1dot1 .step1-options .label').removeClass('invalid');
    recetaHelpers.selectedNotificationError();
    $("#recetaCompleta").attr("data-receta-completa", "");
    $('#recetaRut').val('');
    $('.resultado-busqueda-receta').hide();
    $(".add-to-cart-ryk").prop("disabled", true);
    setTimeout(function () {
        $('#subscriptionPlansSelect').trigger('change');
    }, 300);
});


/*
 Este evento se usa en el PDP para el botón de buscar recetas, el botón se puede
 encontrar en el PDP de lentes de contacto y en la modal de selección de cristales en
 el PDP de anteojos opticos y anteojos de sol.
*/
$(document).on("click", ".buscar-receta-button", function (e) {
    e.preventDefault();

    const customerRUTRegex = new RegExp('^([0-9]{7,8}[0-9k]{1})$', 'gi');
    const urlConsultaReceta = $("[data-url-buscar-receta]").data('url-buscar-receta');
    let formReceta = $("form.ajaxRepiteReceta").serializeArray();
    const tipoProducto = $("[data-tipo-producto]").val();
    const indexed_array = {};
    let valid = true;

    $(".add-cart-btn-container").removeClass("d-none");
    $("#rombos").removeClass("d-flex").addClass("d-none");
    $("#resultadosReceta").html("");

    $.map(formReceta, function (n, i) {
        indexed_array[n["name"]] = n["value"];
    });

    formReceta = indexed_array;

    if (tipoProducto) {
        formReceta.tipoProducto = tipoProducto;
    }

    if (customerRUTRegex.test(formReceta.rut)) {
        recetaHelpers.toggleError('', false);
        formReceta.rut = formReceta.rut.slice(0, formReceta.rut.length-1) + '-' + formReceta.rut.slice(formReceta.rut.length-1);
    } else {
        let tmpl = document.querySelector("#resultadosRecetaBusqueda");
        let clone = tmpl.content.cloneNode(true);
        const msg = $('input[data-error-rut]').data('error-rut');
        clone.querySelector(".busca-receta-tus-datos").remove();
        if (clone.querySelector(".busca-tu-receta-atributos")) {
            clone.querySelector(".busca-tu-receta-atributos").remove();
        }
        if (clone.querySelector(".results")) {
            clone.querySelector(".results").remove();
        }
        if (clone.querySelector('.resultado-receta-pdp')) {
            clone.querySelector('.resultado-receta-pdp').remove();
        }
        if (clone.querySelector('.cantidad-ultima-receta')) {
            clone.querySelector('.cantidad-ultima-receta').remove();
        }
        recetaHelpers.toggleError(msg, true);
        valid = false;
    }

    if (!pdpHelpers.validateSubscriptionEyeSelection()) {
        valid = false;
    }

    if (!pdpHelpers.validateOnEyeEyeSelection()) {
        valid = false;
    }

    const isButtonDisabled = $('.buscar-receta-button').hasClass('disabled');

    if (valid && !isButtonDisabled) {
        $('.buscar-receta-button').addClass('disabled');

        $.ajax({
            headers: { Accept: 'application/json' },
            url: urlConsultaReceta,
            method: 'POST',
            data: formReceta,
            success: function (datos) {
                // Respuesta al servicio
                datos = datos.datos;
                var template = document.querySelector("#resultadosRecetaBusqueda");
                if (datos.length > 1) {
                    for (key in datos) {
                        element = JSON.parse(datos[key]);
                        recetaHelpers.putDataInTemplate(element, template, key);
                    }
                } else {
                    datos = JSON.parse(datos);
                    recetaHelpers.putDataInTemplate(datos, template);
                }

                recetaHelpers.displaySelectedEyeRecipeRows();
                recetaHelpers.canBeAddedToCart();
            }
        }).done(function ( data ) {
            $('.buscar-receta-button').removeClass('disabled');
        }).fail(function ( data ) {
            $('.buscar-receta-button').removeClass('disabled');
        });
    }

    return false;
});
